<template>
  <div
    id="app"
    :data-route="setRouteClass()"
  >
    <MainMenu />
    <keep-alive>
      <RouterView
        class="sb_main-container"
      />
    </keep-alive>
    <Symbols />
    <MainFooter />
    <PopupModal
      v-if="axiosError"
      :header-text="'Connection Error'"
      @close="axiosError = null"
    >
      <p>error message: {{ axiosError }}</p>
    </PopupModal>
  </div>
</template>

<script>
import axios from 'axios';
import PopupModal from '@/components/objects/popup-modal';
import MainFooter from '@/components/assemblies/main-footer';
import MainMenu from '@/components/assemblies/main-menu';
import Symbols from '@/components/svg-symbols';

export default {
  name: 'App',
  components: {
    MainFooter,
    MainMenu,
    Symbols,
    PopupModal
  },
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      axiosError: null
    };
  },
  computed: {},
  watch: {
    // show footer on each route
    $route() {
      this.setRouteClass();
    }

  },
  mounted() {
    console.log(`AW Calculator ${this.version}`);
  },
  created() {
    // apply interceptor on response
    axios.interceptors.response.use(
      response => response,
      this.errorResponseHandler
    );
    this.setRouteClass();
  },
  methods: {
    setRouteClass() {
      return `s_route_${this.$route.name}`;
    },
    // eslint-disable-next-line consistent-return
    errorResponseHandler(error) {
      // check for errorHandle config
      if (
        // eslint-disable-next-line no-prototype-builtins
        error.config.hasOwnProperty('errorHandle')
        && error.config.errorHandle === false
      ) {
        return Promise.reject(error);
      }

      this.axiosError = error.response || error.message || 'no error message defined';
    }
  }
};
</script>

<style lang="scss">
  @import '@/styles/app.scss';

  //
  //    FADE ANIMATION
  //
  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }


  //
  //    HTML COMPACT STATE
  //
  html {
    font-size: 14px;
    &.s_compact {
      font-size: 13px;
    }
  }

  //
  //    MAIN CONTAINER
  //
  .sb_main-container {
    min-height: calc(100vh - 273px);
    background-repeat: no-repeat;
    background-position: right bottom;
    background-size: 400px;

    @include media(">=large") {
      background-size: 1000px;
    }
  }

  //
  //    TOOLTIP
  //
 .tooltip {
    z-index:100;

    &.popover {
      $color: #fff;
      min-width: 360px;

      .popover-inner {
        padding: 2rem;
        color: black;
        background: $color;
        border-radius: 5px;
        box-shadow: 0 5px 30px rgba(black, .1);
      }

      .popover-arrow {
        border-color: $color;
      }
    }
  }

  .tooltip-btn-close {
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: $brand-primary;
  }

  .tooltip-arrow {
    z-index: 1;
  }
</style>
